module.exports = __webpack_public_path__ + "static/img/8.28e7179.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/10/zh/8.png
// module id = stlz
// module chunks = 0